export default __webpack_public_path__ + "static/media/watch-2.21a27572.png";